import React from "react";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router";
import ChatForm from "app/components/ChatForm";

import LayoutUser from "app/components/LayoutUser";

import "./styles.scss";
import {
    changeTelegram,
    getExistingChats,
    openSocket,
    postMessage,
    loadClientMessages,
    getTelegramName,
    notifyTyping
} from "app/api/redux/Chat/actions";
import {ClientLocal} from "app/api/types";
import {BroadcastingType, socket} from "app/api/socket";

interface IProps extends RouteComponentProps {
    notifyTyping: (clientId: number) => any,
    getTelegramName: () => void,
    getExistingChats: () => Promise<void>;
    loadClientMessages: (clientId: number) => any,
    postMessage: (receiverId: number, message: string) => Promise<void>;
    openSocket: () => void;
    changeTelegram: (name: string) => Promise<void>;
    clients: ClientLocal[];
    socket: BroadcastingType | null;
    telegram: string;
}

class ChatPage extends React.Component<IProps> {
    componentDidMount() {
        if (!this.props.telegram) {
            this.props.getTelegramName();
        }
        this.props.getExistingChats();
        this.props.openSocket();
    }

    render() {
        const isSocketAvailable = this.props.socket?.isAlive;

        if (!isSocketAvailable) {
            return (<LayoutUser>Ошибка соединения с сервером</LayoutUser>)
        }

        return (
            <LayoutUser>
                <ChatForm
                    notifyTyping={(clientId) => this.props.notifyTyping(clientId)}
                    clients={this.props.clients}
                    loadClientMessages={(clientId) => this.props.loadClientMessages(clientId)}
                    postMessage={(receiverId, message) => this.props.postMessage(receiverId, message)}
                    changeTelegram={name => this.props.changeTelegram(name)}
                    telegram={this.props.telegram}
                />
            </LayoutUser>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        clients: state.chat.chats as ClientLocal[],
        socket: socket,
        telegram: state.chat.telegram as string,
    };
};

export default withRouter(
    connect(mapStateToProps, {notifyTyping, getTelegramName, getExistingChats, loadClientMessages, postMessage, openSocket, changeTelegram})(ChatPage)
);
